export default __webpack_public_path__ + "static/media/plus.3724780a.svg";